// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"FZ-z","vrsnlCrossSiteLabel":"GZ-z"};